var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeSlated01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6318 2.36816C23.1228 6.85919 23.1228 14.1406 18.6318 18.6316C14.3309 22.9325 7.47106 23.1146 2.95347 19.178C2.75646 19.0064 2.65795 18.9205 2.61348 18.8032C2.57607 18.7044 2.57188 18.5824 2.60244 18.4813C2.63875 18.3612 2.73717 18.2628 2.934 18.0659L5.14925 15.8507M18 10.4999C18 14.642 14.6422 17.9999 10.5 17.9999C6.35791 17.9999 3.00004 14.642 3.00004 10.4999C3.00004 6.35776 6.35791 2.99989 10.5 2.99989C14.6422 2.99989 18 6.35776 18 10.4999Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeSlated01);
export default __webpack_public_path__ + "static/media/globe-slated-01.dd8626c76ba730fddbf293d95ebfa16a.svg";
export { ForwardRef as ReactComponent };